import { Flex, Text } from '@weareberyl/design-system'
import { SCHEME_EMOJIS } from '~/constants/domain'
import { useCurrentScheme } from '~/hooks'

export type Scheme = {
  id: string
  name: string
}

interface Props {
  scheme: Scheme
}

const SchemeButton = ({ scheme }: Props) => {
  const { setSchemeIdAndUpdateLocation } = useCurrentScheme()
  return (
    <button
      style={{
        cursor: 'pointer',
        border: 0,
        padding: 0,
        background: 'none',
      }}
      key={scheme.id}
      title={`Switch to ${scheme?.name ?? scheme.id}`}
      onClick={() => setSchemeIdAndUpdateLocation(scheme.id)}
    >
      <Flex alignItems="center" style={{ flexWrap: 'nowrap' }}>
        <Text>{SCHEME_EMOJIS[scheme.id]}</Text>
        <Text variant="mini" ml={2}>
          {scheme?.name ?? scheme.id}
        </Text>
      </Flex>
    </button>
  )
}

export default SchemeButton
